import { createContext } from 'react';

export const defaultContext = {
  isOpen: false,
  setIsOpen: () => {},
  menu: [{ id: 'presets' }],
  setMenu: () => {},
  back: () => {},
};

export const DevToolsContext = createContext(defaultContext);
